import { render } from "./MsPopoverContainer.vue?vue&type=template&id=1851df12&scoped=true"
const script = {}

import "./MsPopoverContainer.vue?vue&type=style&index=0&id=1851df12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1851df12"]])

export default __exports__